import React, {useState, useEffect, useRef} from "react";
import "./App.css"
import Game from "./Game"
import {DataProvider} from "./DataContext";
import {HashProvider} from "./HashContext";
import Setup from "./Setup";
import Prefs from "./Prefs";
import WordDisplay from "./WordDisplay";
import TextDisplay from "./TextDisplay";
import {localStorageSetItem, localStorageGetItem, switchUsername} from "./misc";
import {StatsProvider} from "./StatsContext"
import {ServerProvider} from "./ServerContext"
import {getExElementGetInfoFunctionList} from "./exTypeList";
import CourseViewer from "./CourseViewer";
import ErrorBoundary from "./ErrorBoundary";


const App = () => {

    const username = localStorage.getItem('currentUsername') || null;

    const audioVoice = localStorageGetItem('audioVoice') || null;

    // Managing current page for re-rendering
    const [page, setPage] = useState(() => {
        return (!username || !audioVoice
            ? "prefs"
            : localStorageGetItem('page') || "setup");
    })
    useEffect(() => {
        localStorageSetItem('page', page);
    }, [page]);


    // The params contains all the parameters to remember before displaying a page
    // It is needed for the page to be re-rendered from scratch
    const [params, setParams] = useState(() => {
        let res = JSON.parse(localStorageGetItem('params')) || null;
        if (res !== null && res?.getInfoFunctionStr) {
            res.getInfoFunction = getExElementGetInfoFunctionList()[res.getInfoFunctionStr]
            res.element = res.getInfoFunction({})[0].element
        }
        return res;
    });
    useEffect(() => {
        localStorageSetItem('params', JSON.stringify(params));
    }, [params]);

    //
    // RENDERING
    //
    return (
        <ErrorBoundary>
            <ServerProvider>
                <HashProvider>
        <StatsProvider>
            <DataProvider>
                <div className="app">
                    {page === "prefs"
                        ? (<Prefs onBack={() => setPage("setup")}/>)
                        : (page === "setup"
                            ? (<Setup
                                onPrefs={() => {
                                    setPage("prefs");
                                }}
                                onWordDisplay={(obj) => {
                                    setParams(obj);
                                    setPage("worddisplay");
                                }}
                                onTextDisplay={(obj) => {
                                    setParams(obj);
                                    setPage("textdisplay");
                                }}
                                onRunGame={(obj) => {
                                    setParams(obj);
                                    setPage("game");
                                }}
                                onCourse={(filename) => {
                                    setParams(filename);
                                    setPage("course");
                                }}
                            />)
                            : (page === "game"
                                ? (<Game gameParams={params} onEndGame={() => setPage("setup")}/>)
                                : (page === "worddisplay"
                                    ? (<WordDisplay texts2Display={params} onBack={() => setPage("setup")}/>)
                                    : (page === "textdisplay"
                                            ? (<TextDisplay texts2Display={params} onBack={() => setPage("setup")}/>)
                                            : page === "course"
                                                ? (<CourseViewer lessons={params} onBack={() => setPage("setup")}/>)
                                                : null
                                    ))))
                    }
                </div>
            </DataProvider>
        </StatsProvider>
                    </HashProvider>
                </ServerProvider>
        </ErrorBoundary>
    );
};

export default App;
